export default function preloaderGame10 (scene) {

    scene.load.image(`tilesgame10`, `/tiles/game10.png`);
    scene.load.image(`copa1`, `/tiles/game10.png`);

	scene.load.audio("oddEyeSong", ["/audio/songs/10-oddeye.mp3"]);

	scene.load.spritesheet(`jiu-game10`, 
		`/img/game10/jiu.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`sua-game10`, 
		`/img/game10/sua.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`siyeon-game10`, 
		`/img/game10/siyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong-game10`, 
		`/img/game10/handong.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon-game10`, 
		`/img/game10/yoohyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`dami-game10`, 
		`/img/game10/dami.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon-game10`,
		`/img/game10/gahyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`copa1-game10`,
		`/img/game10/copa-1.png`,
		{ frameWidth: 7, frameHeight: 12}
	);
	
	scene.load.spritesheet(`copa2-game10`,
		`/img/game10/copa-2.png`,
		{ frameWidth: 7, frameHeight: 12}
	);
	
	scene.load.tilemapTiledJSON(`game10`, `/tiles/game10.tmj`);

}